import { REPORT } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { average, countUnique, sum } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { styleDateRange } from '@utils/styles';

interface SuccessfulCutsByModelProps {
    dateRange: { startDate: string; endDate: string };
}

export const SuccessfulCutsByModel = ({ dateRange }: SuccessfulCutsByModelProps) => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.PRODUCTS_SUCCESSFUL_CUT_VOLUME_BY_MODEL,
        params: { ...dateRange },
    });

    return (
        <BaseReport
            title={'Successful Cuts by Model'}
            description={
                'This table shows you the % breakdown of each device that you cut, along with the number of cuts, for the entire date range above.'
            }
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Model Name', '% of Cuts', 'Manufacturer', 'Successful Cuts'],
                data: data.map((item) => [item.modelName, item.modelPct, item.manufacturer, item.successfulCuts]),
                summaries: [countUnique, average, countUnique, sum],
                sort: [basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
